export default __webpack_public_path__ + "b0a82dbd1192edd3e9cece8c8e7a2bc0.svg";